<app-view-title Title="{{ 'Intellitrailer.Rental.ReturnComplete.Headline' | translate : 'Return complete!' }}" [isPrimaryColor]="true"></app-view-title>
<div class="view-content centered-view">
  @if(!loading) {
  <ng-container>
    <app-information-screen [centered]="true" [secondaryColor]="true"
                        primaryContent="{{ primaryContent }}"
                        image="/assets/Images/big-checkbox-white.png"
                              [showInvite] ="hasActiveCampaign" [discounts]="discount">


      </app-information-screen>
  </ng-container>
  }
  @else if (loading) {
  <ng-container>
    <div style="margin:auto; padding-top:15px; width: 100px; height: 100px; top:55vh; left: 35%; display: inline-block">
      <mat-progress-spinner diameter="50" mode="indeterminate" style="margin:auto"></mat-progress-spinner>
      <div style="text-align: center; width: 100px; margin-top: 25px">
        {{ 'Intellitrailer.Rental.ReturnComplete.LoadingReturn' | translate : 'Loading...' }}
      </div>
    </div>
  </ng-container>
  }
</div>
<div class="view-actions">
  @if(!loading) {
  <button mat-raised-button color="accent" (click)="confirm()">{{ 'Intellitrailer.Rental.ReturnComplete.cmdConfirm' | translate : 'OK' }}</button>
  }
</div>

